import CreatePasswordPage, { CreatePasswordPageProps } from './CreatePasswordPage';

export type { CreatePasswordPageProps };
export default CreatePasswordPage;
